import Api from 'src/api/API';

export default {
    Add(data) {
        return Api.post('/Auth/MailingLists/'+data.mailinglists_id+'/Email', data);
    },
    Delete(MailingListID, MailingListEmailID) {
        return Api.delete('/Auth/MailingLists/'+MailingListID+'/Email/'+MailingListEmailID);
    }
};
